import { css } from '@emotion/react'
import Actions from 'components/App/DesktopView/shared/Composer/Header/Actions'
import Label from './Label'
import Row from './IndentedRow'
import RecipientsEditor from './RecipientsEditor'

const flexStyle = css`
  flex: 1 0 100%;
`

export default function CcRow({
  className,
  ccVisible,
  bccVisible,
  fromVisible,
  subjectVisible,
  onActionClick,
  shouldShowActions,
  ...rest
}) {
  const { ticketId, onUpdate } = rest
  return (
    <Row css={flexStyle} className={className}>
      <Label>CC:</Label>
      <RecipientsEditor
        key={`recipientseditor-cc-${ticketId}`}
        className="grui ml-3"
        type="cc"
        onUpdateCustom={onUpdate}
        {...rest}
      />
      {shouldShowActions && (
        <div className="grui flex actions">
          <Actions
            hideCc
            hideFrom={fromVisible}
            hideBcc={bccVisible}
            hideSubject={subjectVisible}
            onClick={onActionClick}
          />
        </div>
      )}
    </Row>
  )
}
